import React from "react";

export function useToggle(initialValue = false) {
  const [value, setValue] = React.useState(initialValue);

  const setOn = React.useCallback(() => setValue(true), []);
  const setOff = React.useCallback(() => setValue(false), []);
  const toggle = React.useCallback(
    (newValue?: boolean) => setValue((v) => newValue ?? !v),
    [],
  );

  return React.useMemo(
    () => ({ value, toggle, setOn, setOff }),
    [value, toggle, setOn, setOff],
  );
}
